export default __webpack_public_path__ + "static/media/NH21_723_ELLE_LUISA_2389.9fb4df85.jpg";